import React from 'react'
import PropTypes from 'prop-types'

export default class MenuItem extends React.Component {

  static defaultProps = {
    level: 0
  }

  static propTypes = {
    selected: PropTypes.bool,
    level: PropTypes.number,
    display: PropTypes.string.isRequired,
    children: PropTypes.any,
    onOptionClicked: PropTypes.func.isRequired,
    style: PropTypes.object
  }

  render() {
    return (
      <div style={{ ...this.props.style, ...styles.container }}>
        <div style={styles.item(this.props.selected, this.props.level)}
          onClick={this.props.onOptionClicked}>
          { this.props.display }
        </div>
        { this.props.children }
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  item: (selected, level) => ({
    fontSize: level === 1 ? 14 : 18,
    fontWeight: level === 1 ? 300 : 500,
    backgroundColor: selected ? 'rgba(219, 239, 255, 0.5)' : '#fff',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 24 * (level + 1),
    paddingRight: 32,
    textAlign: 'left',
    cursor: 'pointer'
  })
}



// WEBPACK FOOTER //
// ./src/settings/MenuItem.js